export const activeVDDUrl =
  "/workspaces/:workspace_id/modules/vendor-due-diligence/active";
export const allContracts =
  "/workspaces/:workspace_id/modules/vendor-due-diligence/contracts";
export const templatesVDDUrl =
  "/workspaces/:workspace_id/modules/vendor-due-diligence/templates";
export const RATemplatesVDDUrl =
  "/workspaces/:workspace_id/modules/vendor-due-diligence/risk-assessment-templates";
export const inactiveVDDUrl =
  "/workspaces/:workspace_id/modules/vendor-due-diligence/inactive-vendors";
